import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MobileCtaBar from "@/components/MobileCtaBar";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import { ConsultationProvider } from "@/components/ConsultationProvider";
import { ContentProvider } from "@/context/ContentProvider";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Gallery from "@/pages/Gallery";
import Admin from "@/pages/Admin";
import QuoteView from "@/pages/QuoteView";
import AgreementView from "@/pages/AgreementView";
import Guides from "@/pages/Guides";
import GuidePost from "@/pages/GuidePost";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isBare = pathname.startsWith("/admin") || pathname.startsWith("/quote");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <ConsultationProvider>
      <ScrollToTop />
      <AnalyticsTracker />
      <div className={isBare ? "" : "pb-[76px] md:pb-0"}>
        {!isBare && <Navbar />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/quote/:id" element={<QuoteView />} />
          <Route path="/quote/:id/agreement" element={<AgreementView />} />
          <Route path="/guides" element={<Guides />} />
          <Route path="/guides/:slug" element={<GuidePost />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        {!isBare && <Footer />}
        {!isBare && <MobileCtaBar />}
      </div>
      <Toaster position="top-center" richColors />
    </ConsultationProvider>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ContentProvider>
          <Shell />
        </ContentProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
